// https://github.com/axios/axios
import wopi from '@/plugins/axios/wopi'
import externalServices from '@/plugins/axios/external'
import http, { onAccessTokenRefreshed } from '@/plugins/axios/http'
import httpNoAuthorizationHeader from '@/plugins/axios/httpNoAuthorizationHeader'

export { http, httpNoAuthorizationHeader, wopi, externalServices, onAccessTokenRefreshed }
